import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';

import { ModalDesktop } from './modal-desktop';
import { ModalMobile } from './modal-mobile';
import type { LinkModalProps } from './types';

export const LinkModal: React.FC<LinkModalProps> = props => {
  const { isMobile } = useContext(RicosContext);

  return isMobile ? <ModalMobile {...props} /> : <ModalDesktop {...props} />;
};
